'use strict';

function initTurntoSiteIntegrations() {
    // grab the site pref integration object
    var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
    var toggleObject = siteIntegrations.getIntegrationSettings();

    if (toggleObject.turntoCartridgeEnabled) {
        // render star ratings on each tile on ajax calls
        $('body').on('search:showMore--success search:filter--success search:sort--success', () => {
            var teasersModules = require('./teaser/teasersModules');
            teasersModules.generateRatingStars();
        });
    }
}


module.exports = {
    initTurntoSiteIntegrations: initTurntoSiteIntegrations
};
